import React from "react";
import { Box, Button, Select, SelectOption, Separator, Switch } from "@showitinc/showit-wc";

import LanguageOptions from "../../../components/sitesettings/LanguageOptions";
import SiteSettingsActions from "../../../actions/SiteSettingsActions";
import PropertyEditor from "../../../components/PropertyEditor";
import { formatPropUpdate } from "../../../utils/PropertyUtils";

const PagePropertiesAdvanced = ({ onPropUpdate, page }) => {
  const _onPropChange = (propInfo) => (onPropUpdate ? onPropUpdate(propInfo) : undefined);

  return (
    <>
      <Select
        helpTooltip="page-language"
        label="Page Language"
        reserveContext
        shift="left"
        filter
        value={page.getIn(["meta", "language"], "site")}
        onSISelect={(e) => {
          _onPropChange(
            formatPropUpdate("meta.language", e.target.value, page.getIn(["meta", "language"]))
          );
        }}
      >
        <SelectOption value="site">Use Default</SelectOption>
        <LanguageOptions />
      </Select>
      <Box pl="3" my="1" mb="3">
        <Button
          variant="outline"
          lowercase
          onSIClick={() => SiteSettingsActions.openDialogWithSection()}
        >
          Site Language Settings
        </Button>
      </Box>

      <Separator />

      <PropertyEditor
        propName="meta.head"
        value={page.getIn(["meta", "head"])}
        label="Custom Head HTML"
        isHTML
        onChange={_onPropChange}
        language="html"
      />
      <PropertyEditor
        propName="meta.customCSS"
        value={page.getIn(["meta", "customCSS"])}
        label="Custom CSS"
        onChange={_onPropChange}
        language="css"
      />
      <PropertyEditor
        propName="meta.inlineJS"
        value={page.getIn(["meta", "inlineJS"])}
        label="Inline Javascript"
        onChange={_onPropChange}
        language="javascript"
      />
      <PropertyEditor
        propName="meta.pageInitJS"
        value={page.getIn(["meta", "pageInitJS"])}
        label="Page Loaded Javascript"
        onChange={_onPropChange}
        language="javascript"
      />

      <Switch
        label="Ask Google to ignore this page"
        checked={page.getIn(["meta", "noindex"], false)}
        helpTooltip="seo-noindex"
        onClick={(e) =>
          _onPropChange(
            formatPropUpdate(
              "meta.noindex",
              e.target.checked ? 1 : null,
              page.getIn(["meta", "noindex"])
            )
          )
        }
      />
    </>
  );
};

export default PagePropertiesAdvanced;
